import 'css-chunksrc/client/common/window/styles.scss';export default {
  "window": "_window_gu0ne_1",
  "overlay": "_overlay_gu0ne_10"
};